// import action
import { decodeJwt } from "./jsonWebToken";

// import config
import axios, { setAuthorization } from "../config/axios";

export const addNewPair = async (data) => {
  console.log(data, "datadata");
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/addNewPair`,
      data,
    });
    return {
      status: respData.data.data.status ? "success" : "Failed",
      loading: false,
      message: respData.data.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};
export const getPairs = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/getAllPairsList`,
    });
    console.log(respData.data.data.data, "respData___getPairs");
    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
      result: respData.data.data.data.allThePairs,
      count: respData.data.data.data.count,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};

export const getSchedules = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `/market/get-schedules`,
    });
    console.log(respData, "respData___getPairs");
    return {
      status: "success",
      loading: false,
      message: respData.data.message,
      result: respData.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};
export const getPair = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/currencyapi/get-pair`,
      data: data,
    });
    console.log(respData, "respData");
    return {
      status: "success",
      loading: false,
      message: respData.data.message,
      result: respData.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};
export const editSinglePair = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/editSinglePair`,
      data: data,
    });
    console.log(respData.data.data.data, "respData.data.data.data");
    return {
      status: respData.data.data.status ? "success" : "Failed",
      loading: false,
      message: respData.data.data.message,
      result: respData.data.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};
export const deleteSinglePair = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/deletePair`,
      data: data,
    });
    console.log(respData, "respData");
    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
      result: respData.data.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};

export const deleteSingleSchedules = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/market/delete-schedules`,
      data: data,
    });
    console.log(respData, "respData");
    return {
      status: "success",
      loading: false,
      message: respData.data.message,
      result: respData.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};

export const addNewExchange = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/addExchange`,
      data: data,
    });
    console.log(respData, "respData");
    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
      result: respData.data.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};

export const getExchanges = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/getAllExchangesList`,
      data: data,
    });
    console.log(respData.data.data.data.exchangesList, "respData");
    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
      result: respData.data.data.data.exchangesList,
      count: respData.data.data.count,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};

export const editSingleExchange = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/editExchange`,
      data: data,
    });
    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
      result: respData.data.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};

export const deleteSingleExchange = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/deleteExchange`,
      data: data,
    });
    console.log(respData, "respData");
    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
      result: respData.data.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};

export const addNewPlan = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/createAdminSubscriptionPlan`,
      data: data,
    });
    console.log(respData.data.data.data, "respData");
    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
      result: respData.data.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};
export const getAllPlans = async (data) => {
  try {
    // console.log('datadatadata------', data)
    let respData = await axios({
      method: "post",
      url: `/admin/subscriptionPlansList`,
      data,
    });
    console.log(respData.data.data.data, "respData");
    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
      result: respData.data.data.data.plans,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};
export const editPlan = async (data) => {
  try {
    
    let respData = await axios({
      method: "post",
      url: `/admin/editSubscriptionPlan`,
      data,
    });
   
    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
      result: respData.data.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};
export const deletePlan = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/currencyapi/delete-subscription-plan`,
      data: data,
    });
    console.log(respData, "respData");
    return {
      status: "success",
      loading: false,
      message: respData.data.message,
      result: respData.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};

export const changeStatus = async (data) => {
  try {
    // console.log('data-----', data)
    let respData = await axios({
      method: "post",
      url: `/admin/editSubscriptionPlanStatus`,
      data: data,
    });
    console.log(respData.data.data, "respData");
    return {
      status: respData.data.data.status,
      loading: false,
      message: respData.data.data.message,
      result: respData.data.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};



export const addNewToken = async (data) => {
  console.log(data, "datadata");
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/addSingleToken`,
      data,
    });
    
    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
    };
  } catch (err) {
    console.log('respDatarespData------', err)
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};



export const getAllTokens = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/getAllCurrency`,
      data,
    });
    console.log(respData.data.data.data, "respData");
    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
      result: respData.data.data.data.listOfTokens,
      count: respData.data.data.data.count,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};
export const getSingleToken = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/currencyapi/get-currency`,
      data: data,
    });
    console.log(respData, "respData");
    return {
      status: "success",
      loading: false,
      message: respData.data.message,
      result: respData.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};
export const editSingleToken = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/editSingleToken`,
      data: data,
    });
    console.log(respData, "respData");
    return {
      status: "success",
      loading: false,
      message: respData.data.message,
      result: respData.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};
export const deleteSingleToken = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/deleteSingleToken`,
      data,
    });
    console.log(respData, "respData");
    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
      result: respData.data.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};

export const updateTrendingSuggestedPairs = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/updateTrendingSuggestedPairs`,
      data: data,
    });
    console.log(respData, "respData");
    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
      result: respData.data.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};


export const addTrendingSuggestedPair = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/addTrendingSuggestedPair`,
      data: data,
    });
    console.log(respData, "respData");
    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
      result: respData.data.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};


export const deleteTrendingSuggestedPair = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/deleteTrendingSuggestedPair`,
      data: data,
    });
    console.log(respData, "respData");
    return {
      status: "success",
      loading: false,
      message: respData.data.data.message,
      result: respData.data.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.data.message,
      error: err.response.data.data.data,
    };
  }
};